import Page from '../../components/Page';
import React from 'react';
import {Card, CardBody, CardHeader, Col, Row, Button} from 'reactstrap';
import {Link} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import API from "../../resources/index";

class ManagerDetailPage extends React.Component {
    managerResource = API.managerResource;

    constructor() {
        super();
        this.state = {
            manager: {}
        }
    }

    componentDidMount() {
        if (this.props.match.params && this.props.match.params.manager_id) {
            this.managerResource.fetch(this.props.match.params.manager_id, {keys: {expand: ['auth']}})
                .then(response => {
                    if (response.status === 200)
                        this.setState({manager: response.data});
                })
        }
    }

    async deleteUser(manager) {
        if (window.confirm(`Tem certeza que deseja excluir o gestor "${manager.name}" ?`)) {
            this.managerResource.delete(manager.id)
                .then(response => {
                    if (response.status === 204) {
                        this.props.history.push('/manager');
                    }

                })
        }
    }

    render() {
        const {manager} = this.state;
        const {user} = this.props;

        return <Page
            title='Detalhe Gestor'
            breadcrumbs={[
                {name: 'Gestores', active: false},
                {name: 'Detalhe Gestor', active: true}
            ]}
            className="">
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            <Link className='btn btn-outline-secondary mr-2'
                                  to={`/managers`}>
                                Gestores
                            </Link>

                            <Link className='btn btn-outline-secondary mr-2'
                                  to={`/managers/form/${manager.id}`}>
                                Editar
                            </Link>

                            {(manager && user) && (manager.auth_id !== user.id) &&
                            <Button color="danger" onClick={() => this.deleteUser(manager)}>Apagar</Button>}
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col>
                                    <p>Nome</p>
                                    <h4>{manager.name}</h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p>Email</p>
                                    <h4>{manager.auth && manager.auth.email}</h4>
                                </Col>
                                <Col>
                                    <p>Status</p>
                                    <h4>{manager.is_activated ? 'Sim' : 'Não'}</h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <p>Criado em</p>
                                    <h4>{(new Date(manager.created_at)).toLocaleDateString('pt-br')}</h4>
                                </Col>
                                <Col>
                                    <p>Atualizado em</p>
                                    <h4>{(new Date(manager.updated_at)).toLocaleDateString('pt-br')}</h4>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

        </Page>
    };
}

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

export default connect(mapStateToProps)(ManagerDetailPage);



// WEBPACK FOOTER //
// ./src/pages/manager/ManagerDetailPage.js